export default "__VITE_ASSET__B4nDQ0zZ__"